import { Fragment, FunctionComponent } from 'react'

import Skeleton from '@mui/material/Skeleton'
import { range } from 'libraries/lodash'
import cx from 'classnames'

import { LegislationAccodionSkeletonContainerProps } from 'redux/containers/components/accordion/LegislationAccordionSkeletonContainer'

const LegislationAccordionSkeleton: FunctionComponent<LegislationAccodionSkeletonContainerProps> = ({ windowHeight, headerHeight, deviceType }) => (
  <div
    className='w-100 overflow-y-auto bg-page-background flex justify-center scrolling-container flex-wrap'
    style={{ maxHeight: `${windowHeight - headerHeight}px` }}
  >
    <div className='grow-1 shrink-1 basis0 ph0 ma0'>
      <div className='content-view'>
        <div className='layout-width-constraint'>
          <div className='w-100'>
            <AccordionTitle />
            <div className='bg-white pb8 mb6'>
              <GroupHeaderDepth1 />
              <ul className='group cd-accordion-menu'>
                {range(0, 2).map((_, index) => (
                  <Fragment key={index}>
                    <GroupHeaderDepth2 />
                    <ul className='group'>
                      {range(0, 5).map((_, index) => (
                        <GroupHeaderDepth3 key={index} {...{ deviceType }} />
                      ))}
                    </ul>
                  </Fragment>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

const AccordionTitle: FunctionComponent = () => (
  <div className='ma0 pl6 pt8 pb6 bg-white db w-100 o-60'>
    <Skeleton classes={{ root: 'w14 bg-grey', text: 'f3 fw7' }} />
  </div>
)

const GroupHeaderDepth1: FunctionComponent = () => (
  <div
    className='w-100 ma0 pv0 pr6 f5 min-h3 shadow-none fw7 flex items-center justify-between white bg-suez-canal'
    style={{ paddingLeft: '2.75rem' }}
  >
    <div className='o-50 w-100'>
      <Skeleton variant='text' classes={{ root: 'w-80 bg-white', text: 'f5 fw7' }} />
    </div>
    <div className='o-50'>
      <Skeleton variant='circular' classes={{ root: 'bg-white' }} width={24} height={24} />
    </div>
  </div>
)

const GroupHeaderDepth2: FunctionComponent = () => (
  <li>
    <div
      className='w-100 f5 b ma0 pv0 pr6 f5 min-h3 shadow-none flex items-center bb darker bg-powder-white white b--eastern-breeze ie-min-height-flex-items-center-fix group'
      style={{ paddingLeft: '2.75rem' }}
    >
      <div className='o-50 w-100'>
        <Skeleton classes={{ root: 'w12 bg-white o-50', text: 'f5 fw7' }} />
      </div>
      <div className='o-50'>
        <Skeleton variant='circular' classes={{ root: 'bg-white' }} width={24} height={24} />
      </div>
    </div>
  </li>
)

const GroupHeaderDepth3: FunctionComponent<Pick<LegislationAccodionSkeletonContainerProps, 'deviceType'>> = ({ deviceType }) => (
  <li className='mb0'>
    <div
      className={cx(
        'w-100 f5 b ma0 pv0 pr6 min-h3 shadow-none flex items-center bb bg-page-background b--eastern-breeze group',
        { 'flex-wrap': deviceType.isMobile }
      )}
      style={{ paddingLeft: '3.75rem' }}
    >
      <div className='mr6 o-60'>
        <Skeleton variant='text' classes={{ root: 'w9 bg-grey', text: 'f5 fw7' }} />
      </div>
      <div className='flex items-center justify-center justify-between h-100 w-100'>
        <div className={cx('o-60')}>
          <Skeleton variant='text' classes={{ root: 'w14 w8-m bg-grey', text: 'f5 fw7' }} />
          {deviceType.isMobile && <Skeleton variant='text' classes={{ root: 'w8-m bg-grey', text: 'f5 fw7' }} />}
        </div>
        <div className='flex items-center justify-center'>
          <div className='o-60'>
            <Skeleton variant='text' classes={{ root: 'w8 bg-grey', text: 'f6 fw5' }} />
          </div>
          <div className='o-60 ml5'>
            <Skeleton variant='rectangular' classes={{ root: 'bg-grey' }} width={18} height={18} />
          </div>
          <div className='o-60 ml5'>
            <Skeleton variant='circular' classes={{ root: 'bg-grey' }} width={24} height={24} />
          </div>
        </div>
      </div>
    </div>
  </li>
)

export default LegislationAccordionSkeleton
